import { createSlice } from "@reduxjs/toolkit";
import dashboardThunkActions from "./thunk/dashboardThunk";
import extraReducers from "./thunk/dashboardExtraReducers";

export const DASHBOARD_FLOW_SLICE_NAME = "dashboardFlow";

const initialState = {
  businessListing: {
    data: [],
    error: null,
  },
  dashboardGroupListing: {
    data: [],
    error: null,
  },
  dashboardList: {
    data: [],
    error: null,
  },
  homeDashboardListing: {
    data: [],
    error: null,
  },
  reportListingDashboard: {
    data: [],
    error: null,
  },
  reportListing: {
    data: [],
    error: null,
  },
  breadCrumbs: {
    data: [],
    error: null,
  },
  dashboardChartList: {
    data: [],
    error: null,
  },
  chartListing: {
    data: [],
    error: null,
  },
};

export const dashboardFlowSlice = createSlice({
  name: DASHBOARD_FLOW_SLICE_NAME,
  initialState,
  reducers: {
    resetReports: (state, action) => ({
      ...state,
      reportListing: { data: action.payload },
    }),
    setBreadCrumbs: (state, action) => ({
      ...state,
      breadCrumbs: { data: action.payload },
    }),
  },
  extraReducers,
});

export const dashboardActions = {
  ...dashboardFlowSlice.actions,
  ...dashboardThunkActions,
};

export default dashboardFlowSlice.reducer;
